import React, { useState } from "react";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
} from "react-icons/fa";
import { navLinksdata } from "../../constants";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600">

      {/* Brand */}
      <div>
        <Link
          to="home"
          smooth={true}
          duration={500}
          className="cursor-pointer"
        >
          <span className="text-2xl font-bold text-white">
            Sam<span className="text-designColor">.</span>
          </span>
        </Link>
      </div>

      {/* Desktop Navigation */}
      <div>
        <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
          {navLinksdata.map(({ _id, title, link }) => (
            <li
              className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
              key={_id}
            >
              <Link
                activeClass="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          <FiMenu />
        </span>

        {/* Mobile Menu */}
        {showMenu && (
          <div className="w-[80%] h-screen overflow-scroll absolute top-0 left-0 bg-gray-900 p-4 scrollbar-hide">

            <div className="flex flex-col gap-8 py-2 relative">

              {/* Mobile Brand */}
              <div>
                <Link
                  to="home"
                  smooth={true}
                  duration={500}
                  onClick={() => setShowMenu(false)}
                  className="cursor-pointer"
                >
                  <span className="text-2xl font-bold text-white">
                    Sam<span className="text-designColor">.</span>
                  </span>
                </Link>

                <p className="text-sm text-gray-400 mt-2">
                  Technology • Film & Media • Photography • Education
                </p>
              </div>

              {/* Mobile Navigation */}
              <ul className="flex flex-col gap-4">
                {navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>

              {/* Social Links */}
              <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">
                  Find me in
                </h2>

                <div className="flex gap-4">

                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/ShamimRahmanSam.Official/"
                    target="_blank"
                    rel="noreferrer"
                    className="bannerIcon"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>

                  {/* LinkedIn */}
                  <a
                    href="https://www.linkedin.com/in/srsam"
                    target="_blank"
                    rel="noreferrer"
                    className="bannerIcon"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>

                  {/* GitHub */}
                  <a
                    href="https://github.com/ShamimRahmanSam"
                    target="_blank"
                    rel="noreferrer"
                    className="bannerIcon"
                    aria-label="GitHub"
                  >
                    <FaGithub />
                  </a>

                </div>
              </div>

              {/* Close Button */}
              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-designColor duration-300 text-2xl cursor-pointer"
                aria-label="Close menu"
              >
                <MdClose />
              </span>

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;